import { URL_API } from "..";

export const getConnection = async (_cnpj, _user, _password) => {
    
    const data = {
        cnpj: _cnpj,
        user: _user,
        password: _password
    }

    const header = new Headers();

    const params = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(data)
    };

    const request = await fetch(`${URL_API}ERP/getconnection`, params);
    let json = {};

    try{
        json = await request.json();
    }catch(e){
        json.data = null;
    }

    return json;

}

export const getCompany = async (_user) => {

    const header = new Headers();

    const params = {
        method: 'GET',
        headers: header
    };

    const request = await fetch(`${URL_API}erp/getcompanysbyuser`, params);
    let json = {};

    try{
        json = await request.json();
    }catch(e){
        json.data = null;
    }

    return json;

}